// store/slices/uiSlice.ts

export interface UIState {
  sideBarVisible: boolean;
  isProcessingProgressVisible: boolean;
  isBannerVisible: boolean;
}

export interface UIActions {
  setSideBarVisible: (isVisible: boolean) => void;
  setIsProcessingProgressVisible: (isVisible: boolean) => void;
  setBannerVisible: (isVisible: boolean) => void;
}

export const uiSlice = (set: any): { data: UIState; actions: UIActions } => ({
  data: {
    sideBarVisible: true,
    isProcessingProgressVisible: false,
    isBannerVisible: false,
  },
  actions: {
    setSideBarVisible: (visible: boolean) => {
      set((state: any) => {
        state.data.sideBarVisible = visible;
      });
    },
    setIsProcessingProgressVisible: (isVisible: boolean) => {
      set((state: any) => {
        state.data.isProcessingProgressVisible = isVisible;
      });
    },
    setBannerVisible: (isVisible: boolean) => {
      set((state: any) => {
        state.data.isBannerVisible = isVisible;
      });
    },
  },
});
